module.exports = __webpack_public_path__ + "static/img/banner-empleo-home-1024x768.58dd8aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-empleo-home-1024x768.jpg
// module id = /0gD
// module chunks = 47